import { useMutation } from "@tanstack/react-query";
import { customFetcher } from "../useFetch";
import { ICustomer } from "../../interfaces/ICustomer";

/**
 * Hook zum Aktualisieren eines Kunden anhand der ID.
 */
export const useUpdateCustomer = () => {
    const { mutateAsync: updateCustomer, isPending: isPendingUpdateCustomer } = useMutation({
        mutationFn: (customer: ICustomer) =>
            customFetcher({
                endpoint: `/customer/${customer.id}`,
                method: "PUT",
                body: customer,
            }),
    });

    return {
        updateCustomer,
        isPendingUpdateCustomer,
    };
};
